module.exports = __webpack_public_path__ + "static/img/1041_big.27fe517.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1041_big.png
// module id = uMEp
// module chunks = 1